import React from 'react'
import FlexibleLink from 'src/components/ui/FlexibleLink/FlexibleLink'
import { Image } from 'src/components/ui/Image'

interface CartaoPresenteHighlightProps {
  backgroundColor?: string
  leftImage: string
  rightImage: string
  description: string
  primaryButtonText: string
  primaryButtonLink: string
  secondaryButtonText: string
  secondaryButtonLink: string
  banner: string
}

const CartaoPresenteHighlight: React.FC<CartaoPresenteHighlightProps> = ({
  backgroundColor = '#F6F7F8',
  leftImage,
  rightImage,
  description,
  primaryButtonText,
  primaryButtonLink,
  secondaryButtonText,
  secondaryButtonLink,
  banner,
}) => {
  return (
    <section
      className="w-full max-w-[1440px] mx-auto flex-col-reverse md:flex-row flex items-center md:my-[100px]"
      style={{ backgroundColor }}
    >
      <div className="flex flex-col justify-center md:items-start md:w-[53%] w-full md:pl-[150px] items-center">
        <div className="flex pb-[40px] sticky ">
          <Image
            src={leftImage}
            alt="Imagem esquerda"
            className="w-[316px] md:mr-[25px] h-[200px] relative -top-12 md:top-0"
          />
          <Image
            src={rightImage}
            alt="Imagem direita"
            className="hidden md:block w-[316px] h-[200px] md:ml-[25px]"
          />
        </div>

        <p className="text-base text-[#15181B] px-5 pb-[70px] max-w-[500px]">
          {description}
        </p>

        <div className=" p-5 flex w-full gap-4 md:flex-row flex-col">
          <FlexibleLink
            linkUrl={primaryButtonLink}
            classNames="px-4 py-1 md:w-[318px] h-[64px] w-full content-center text-center rounded-full bg-[#3643BA] text-white font-medium"
            label={primaryButtonText}
          />
          <FlexibleLink
            linkUrl={secondaryButtonLink}
            classNames="px-4 py-1 md:w-[234px] w-full h-[64px] content-center text-center rounded-full bg-white text-black font-medium"
            label={secondaryButtonText}
          />
        </div>
      </div>
      <div className="w-full md:w-[47%] flex justify-end">
        <Image src={banner} alt="Banner destaque" className="w-full" />
      </div>
    </section>
  )
}

export default CartaoPresenteHighlight
